import { useEffect, useState } from "react";
import { fromUrlExcursionVendor } from "../../../helper/vendorMask";
import { ApiCall, ExcursionApiCall } from "../../../helper/axios";
import { useLocation, useParams } from "react-router-dom";
import { getUserToken } from "../../../helper/commonFunction";
import { useSelector } from "react-redux";
import moment from "moment";

export const getExcurstionDetails = (options = {}) => {
  const skipFetch = options?.skipFetch === true;
  const { userAgentData } = useSelector((state) => state.userData);
  const onineServicesFees = userAgentData?.onineServicesFees ?? 0;
  const [checkAvailability, setCheckAvailability] = useState(false);
  const [availability, setAvailability] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [personsInfoModal, setPersonsInfoModal] = useState(false);
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showVariations, setShowVariations] = useState(false);
  const [inquiry, setInquiry] = useState(null);
  const [session, setSession] = useState(null);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [verificationData, setVerificationData] = useState(null);
  const [queryData, setQueryData] = useState({});
  const params = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get("id");
  const bid = query.get("bId");
  const [error, setError] = useState(null)
  const [ready,setReady] = useState(false)

  const verifyCheckoutSession = async (token) => {
    try {
      setLoading(true);

      if (!token) {
        return;
      }

      const userToken = getUserToken();

      const session = await ExcursionApiCall(
        "POST",
        "wp-json/dahr/v1/validate-token",
        {
          token: userToken,
          service_token: token,
        },
        {},
        "excursion"
      );

      setVerificationData(session?.data);

      if (session?.data?.valid && session?.data?.data?.token_data) {
        const parsedQuery = new URLSearchParams(
          session.data.data.token_data
        );

        const parsedData = Object.fromEntries(parsedQuery.entries());

        setQueryData(parsedData);
        return parsedData
      } else {
        setError("Checkout session is invalid or has expired. Please try again.");
      }

      return session?.data;
    } catch (error) {
      console.error(error);
      setError?.("Session expired");
    };
  };


  useEffect(() => {
    if (location.pathname !== "/checkout") {
      const paramsData = Object.fromEntries(query.entries());

      setQueryData(paramsData);
    }
  }, [location.search]);

  useEffect(() => {
    const initializeCheckout = async () => {
      if (location.pathname !== "/excursion/checkout") {
        const paramsData = Object.fromEntries(query.entries());
        setQueryData(paramsData);
        setReady(true);
        return;
      }
      if (!token && !bid) {
        setError("Checkout session is invalid or has expired. Please try again.");
        setReady(true);
        return;
      }
      setLoading(true);
      const verifiedData = await verifyCheckoutSession(token);
      if (!verifiedData) {
        setLoading(false);
        return;
      }
      setQueryData(verifiedData);
      setReady(true);
    };

    if(!bid){
      initializeCheckout();
    } else {
      setReady(true);
    }
  }, [token, location.pathname]);


  const id = queryData?.eId || params?.id;
  const variationId = queryData?.vId;
  const resourceId = queryData?.rId;
  const IsEticketRequired = queryData?.eTicket;
  const date = queryData?.d;
  const time = queryData?.t;
  const endTime = queryData?.et;
  const persons = queryData?.p?.split("n");
  const transfer = queryData?.tr;
  const eventId = queryData?.eventId;
  const TourProductId = queryData?.tPid;
  const TourScheduleId = queryData?.tSId;
  const TourId = queryData?.tId;
  const duration = queryData?.tD;
  const jwt = queryData?.jwt;
  const IsEventBased = queryData?.IsEventBased;
  const openDay = queryData?.openDay;
  const vendorBased = queryData?.vendorBased;


  let slotData = null;

  try {
    const searchDataParam = queryData?.slotData;

    if (searchDataParam) {
      const decoded = decodeURIComponent(atob(searchDataParam));

      slotData = JSON.parse(decoded);
    }
  } catch (error) {
    console.error(error);
  }

  // const prices = query
  //   .get("pr")
  //   ?.split("nn")
  //   ?.map((p) => {
  //     return {
  //       type: p?.split("_")?.[0],
  //       price: p?.split("_")?.[1],
  //     };
  //   });

  let prices = {};
  let taxData = {}

  try {
    const encoded = queryData?.pr
    if (encoded) {
      prices = JSON.parse(
        decodeURIComponent(atob(encoded))
      );
    }
  } catch (e) {
    console.error("Invalid pricing data",e);
  }
  try {
    const encoded = queryData?.taxdata ?? query.get("taxdata");
    if (encoded) {
      taxData = JSON.parse(
        decodeURIComponent(atob(encoded))
      );
    }
  } catch (e) {
    console.error("Invalid pricing data",e);
  }

  const adults = +persons?.[0] || 0;

  const child = +persons?.[1] || 0;

  const infants = +persons?.[2] || 0;
  // const infantPrice = prices?.find((p) => p?.type === "Infant")?.price ?? 0;
  // let adultPrice = prices?.find((p) => p?.type === "Adult")?.price ?? 0;
  // let childPrice = prices?.find((p) => p?.type === "Child")?.price ?? 0;
  console.log(prices,taxData)

  const adultBasePice = prices['adult']?.baseAmount
  const childBasePice = prices['child']?.baseAmount
  const infantBasePice = prices['infant']?.baseAmount
  const adultFinalPrice = prices['adult']?.finalAmount
  const childFinalPrice = prices['child']?.finalAmount
  const infantFinalPrice = prices['infant']?.finalAmount
  let totalTax = prices['adult']?.taxAmount * adults
  if(child && child > 0){
    totalTax +=  prices['child']?.taxAmount * child
  }
  if(infants && infants > 0){
    totalTax +=  prices['infant']?.taxAmount * infants
  }

  // if(adultPrice === "false" || adultPrice === false || adultPrice === 'undefined' || adultPrice === 'null' || adultPrice === null){
  //   adultPrice = 0;
  // }

  // if(childPrice === "false" || childPrice === false || childPrice === 'undefined' || childPrice === 'null' || childPrice === null){
  //   childPrice = 0;
  // }

  const hasInfantPrice =
    infantFinalPrice !== undefined && infantFinalPrice !== null && infantFinalPrice !== "";

  let totalPrice = adults * adultFinalPrice;
  if (hasInfantPrice) {
    totalPrice = totalPrice + child * childFinalPrice + infants * infantFinalPrice;
  } else {
    if(childBasePice) {
      totalPrice = totalPrice + (child + infants) * childFinalPrice;
    }
  }
  const onlineServiceFeeAmount = (totalPrice * onineServicesFees) / 100;


  const refresh = async () => {
    try {
      if (!id) {
        return;
      }
      setLoading(true);

      const urlParams = Object.fromEntries(query.entries());
      const src = { ...urlParams, ...queryData };
      if (src.vendor) src.vendor = fromUrlExcursionVendor(src.vendor);

      const parsedTravelDate = moment(src?.["travel-date"], "DD-MM-YYYY", true);
      const parsedFallbackDate = moment(
        src?.d,
        ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY"],
        true
      );
      const travelDate = parsedTravelDate.isValid()
        ? parsedTravelDate.format("MM-DD-YYYY")
        : parsedFallbackDate.isValid()
          ? parsedFallbackDate.format("MM-DD-YYYY")
          : moment().format("MM-DD-YYYY");

      const clean = (v) =>
        v === undefined || v === null || v === "undefined" || v === "null"
          ? ""
          : String(v);

      const detailsPayload = {
        excursionId: clean(id),
        countryId: clean(src?.["country-id"]),
        cityId: clean(src?.["city-id"]),
        travelDate,
        vendor: clean(src?.vendor),
        tourId: clean(src?.["tour-id"]) || clean(src?.tId),
        contractId: clean(src?.["contract-id"]),
        noOfAdult: String(adults || 1),
        noOfChild: String(child || 0),
        noOfInfant: String(infants || 0),
      };

      const detailsCommonId = clean(src?.cId);
      if (detailsCommonId) {
        detailsPayload.commonId = detailsCommonId;
      }

      const details = await ApiCall(
        "POST",
        `/excursions/details`,
        detailsPayload,
        {}
      );

      const body = details?.data;
      const unwrapped = body?.statusCode && body?.data ? body.data : body;
      if (details?.status !== 200 || !unwrapped || unwrapped?.status === "error") {
        console.error("Excursion details failed", details?.status, body);
        setData({});
        setError?.("Unable to load excursion details. Please try again.");
      } else {
        setData(unwrapped);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Re-resolve prices for a newly selected date (lightweight — hits our pricing
  // tables only, no upstream calls) and patch the loaded detail in place. The
  // detail content stays; only the header price and each variation's price move.
  const resolvePricesForDate = async (newDate) => {
    try {
      if (!newDate || !data || Array.isArray(data) || !data?.singleId) return;
      const urlParams = Object.fromEntries(query.entries());
      const src = { ...urlParams, ...queryData };
      if (src.vendor) src.vendor = fromUrlExcursionVendor(src.vendor);
      const clean = (v) =>
        v === undefined || v === null || v === "undefined" || v === "null" ? "" : String(v);
      const travelDate = moment(newDate).format("MM-DD-YYYY");

      const variationIds = Array.isArray(data?.singleExcursionData?.excursion_variations)
        ? data.singleExcursionData.excursion_variations
            .map((v) => String(v?.variation_unique_id ?? ""))
            .filter(Boolean)
        : [];

      const payload = {
        vendor: clean(data?.vendor || src?.vendor),
        tourId: clean(data?.singleId || src?.["tour-id"] || src?.tId || id),
        productId: clean(data?.singleId || id),
        excursionId: clean(id),
        countryId: clean(src?.["country-id"]),
        cityId: clean(src?.["city-id"]),
        travelDate,
        variationIds,
      };

      const res = await ApiCall("POST", "/excursions/resolve-price", payload, {});
      const body = res?.data;
      const unwrapped = body?.statusCode && body?.data ? body.data : body;
      if (!unwrapped) return;

      const flatBlock = (a) => ({ baseAmount: Number(a) || 0, taxAmount: 0, finalAmount: Number(a) || 0 });
      const vmap = unwrapped.variations || {};

      setData((prev) => {
        if (!prev || Array.isArray(prev)) return prev;
        const next = { ...prev };
        if (unwrapped.excursionTaxPricing) next.excursionTaxPricing = unwrapped.excursionTaxPricing;
        // Custom-slot products price from excursionPrice — keep it in sync too.
        if (unwrapped.tour) {
          next.excursionPrice = {
            ...(next.excursionPrice || {}),
            adultPrice: Number(unwrapped.tour.adult) || 0,
            childPrice: Number(unwrapped.tour.child) || 0,
            infantPrice: Number(unwrapped.tour.infant) || 0,
          };
        }
        const sd = next.singleExcursionData;
        if (sd && Array.isArray(sd.excursion_variations)) {
          const variations = sd.excursion_variations.map((v) => {
            const e = vmap[String(v?.variation_unique_id ?? "")];
            if (!e) return v;
            // Only the selling price moves; originalPrices (genuine API cost) stays.
            return {
              ...v,
              variation_start_price: Number(e.adult) || 0,
              prices: { adult: flatBlock(e.adult), child: flatBlock(e.child), infant: flatBlock(e.infant) },
            };
          });
          next.singleExcursionData = { ...sd, excursion_variations: variations };
        }
        return next;
      });

      return unwrapped;
    } catch (error) {
      console.error("resolvePricesForDate error", error);
    }
  };

  const getAvailability = async (
    eid,
    travelDate,
    totalChild,
    totalAdult,
    totalInfant = 0,
    extra = {}
  ) => {
    try {
      if (!eid) {
        return;
      }

      setCheckAvailability(true);

      const payload = {
        vendor: extra?.vendor ?? data?.vendor ?? "",
        excursionId: String(eid),
        travelDate,
        totalAdult: String(totalAdult ?? 0),
        totalChild: String(totalChild ?? 0),
        totalInfant: String(totalInfant ?? 0),
      };

      const commonId = extra?.commonId ?? data?.commonId;
      if (commonId) payload.commonId = commonId;

      if (extra?.contractId) payload.contractId = String(extra.contractId);
      if (extra?.tourOptionId) payload.tourOptionId = String(extra.tourOptionId);
      if (extra?.transferId) payload.transferId = String(extra.transferId);
      if (extra?.startTime) payload.startTime = String(extra.startTime);
      if (extra?.exitTime) payload.exitTime = String(extra.exitTime);

      const details = await ApiCall(
        "POST",
        `/excursions/check-availability`,
        payload,
        {}
      );

      const body = details?.data;
      const unwrapped = body?.statusCode && body?.data ? body.data : body;

      setAvailability(unwrapped);

      return unwrapped;
    } catch (error) {
      console.error(error);
    } finally {
      setCheckAvailability(false);
    }
  };


  const raiseInquiry = async (
    eid,
    travelDate,
    totalChild,
    totalAdult,
    numberOfPersons
  ) => {
    try {
      if (!eid) {
        return;
      }

      setCheckAvailability(true);

      const userToken = getUserToken();

      const details = await ApiCall(
        "POST",
        `raiseAnExcursionInquiry`,
        {
          userToken: userToken,
          excursion_id: eid,
          numberOfPerson: numberOfPersons,
          totalAdult,
          totalChild,
          travelDate,
        },
        {},
        "excursion"
      );

      setInquiry(details?.data);

      return details?.data;
    } catch (error) {
      console.error(error);
    } finally {
      setCheckAvailability(false);
    }
  };

  const createCheckoutSession = async (url) => {
    try {
      setCheckoutLoading(true);

      if (!url) {
        return;
      }

      let tokenData = url;
      try {
        const sp = new URLSearchParams(window.location.search);
        const backParams = new URLSearchParams();
        ["vendor", "tour-id", "contract-id", "country-id", "city-id", "city", "travel-date", "cId"].forEach((key) => {
          const value = sp.get(key);
          if (value != null && value !== "") backParams.set(key, value);
        });
        const extra = backParams.toString();
        if (extra) tokenData = `${url}&${extra}`;
      } catch (e) {}

      const userToken = getUserToken();

      const session = await ExcursionApiCall(
        "POST",
        "wp-json/dahr/v1/create-token",
        {
          token: userToken,
          token_data: tokenData,
          service_type: "excursion",
        },
        {},
        "excursion"
      );

      setSession(session?.data);

      return session?.data;
    } catch (error) {
      console.error(error);

      return null;
    } finally {
      setCheckoutLoading(false);
    }
  };

  useEffect(() => {
    if (skipFetch) {
      return;
    }

    const element = document.querySelector(
      ".hw-widget--excursionDetails"
    );

    if (element) {
      element?.scrollIntoView?.({
        behavior: "smooth",
        block: "start",
      });
    }

    if (location.pathname === "/checkout") {
      if (!queryData?.eId) {
        return;
      }
    }
    refresh();
  }, [id, skipFetch]);

  return {
    refresh,
    resolvePricesForDate,
    availability,
    checkAvailability,
    getAvailability,
    data,
    loading,
    personsInfoModal,
    setPersonsInfoModal,
    showTypeDropdown,
    setShowTypeDropdown,
    showModal,
    setShowModal,
    variationId,
    date,
    time,
    endTime,
    eventId,
    persons,
    transfer,
    id,
    showVariations,
    setShowVariations,
    totalPrice,
    adultPrice : adultFinalPrice,
    infantPrice : hasInfantPrice ? infantFinalPrice : childFinalPrice,
    childPrice : childFinalPrice,
    TourProductId,
    TourScheduleId,
    TourId,
    duration,
    jwt,
    ageGroup: {
      adults: { name: "Adult", count: adults, price: adultBasePice },
      child: { name: "Child", count: child, price: childBasePice },
      infants: {
        name: "Infant",
        count: infants,
        price:
          infantBasePice !== undefined && infantBasePice !== null && infantBasePice !== ""
            ? infantBasePice
            : childBasePice,
      },
    },
    onlineServiceFeeAmount,
    IsEventBased,
    raiseInquiry,
    inquiry,
    setInquiry,
    openDay,
    vendorBased,
    slotData,
    resourceId,
    IsEticketRequired,
    totalTax,
    taxData,
    pricesObject : prices,
    createCheckoutSession,
    checkoutLoading,
    verificationData,
    commonId: queryData?.cId || data?.commonId || "",
    queryData,
    error, setError , ready
  };
};
